module.exports = __webpack_public_path__ + "img/jf_rule.06929c52.jpg";